<template>
  <el-container>
    <el-main class="flex flex-column" style="padding-right: 0;">
      <el-table
        :data="rows"
        size="medium"
        class="qaac-table"
        style="width: 100%; flex: 1 1 0%;"
        height="250"
      >
        <slot name="empty" slot="empty" />
        <el-table-column
          prop="title"
          label="标题"
          header-align="center"
          min-width="300"
        >
          <template slot-scope="{ row }">
            <slot name="title" :row="row" />
          </template>
        </el-table-column>
        <el-table-column
          prop="published"
          label="发布状态"
          header-align="center"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <el-tag v-if="!row.published || row.expired" type="info"
              >未发布</el-tag
            >
            <el-tag v-else-if="row.effective" type="success">已发布</el-tag>
            <el-tag v-else type="warning">待发布</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="postTimes"
          label="收集数量"
          header-align="right"
          align="right"
        ></el-table-column>
        <el-table-column header-align="center" align="right" min-width="150">
          <template slot="header" slot-scope="scope">
            <div
              class="flex flex-column v-center h-right cell"
              style="display: flex;"
            >
              <el-select
                v-model="dateColumn"
                size="mini"
                :key="scope.$index"
                style="width: 100px;"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </template>
          <template slot-scope="{ row }">
            {{ obtainDate(row) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="180" align="center">
          <template slot-scope="scope">
            <operator-column
              :row="scope.row"
              :index="scope.$index"
              @publish="handlePublish"
              @unpublish="handleUnpublish"
              @share="handleShare"
              @command="handleCommand"
            />
          </template>
        </el-table-column>
      </el-table>
      <el-footer
        style="display: flex; justify-content: center; align-items: flex-end;"
      >
        <el-pagination
          background
          hide-on-single-page
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </el-footer>
    </el-main>
  </el-container>
</template>

<script>
import { Container, Main, Footer } from "element-ui";
import { Table, TableColumn, Pagination } from "element-ui";
import { Tag, Message, MessageBox } from "element-ui";
import { Select, Option } from "element-ui";
import OperatorColumn from "@/components/collector/OperatorColumn";
export default {
  name: "questionnaire-table-home",
  components: {
    OperatorColumn,
    [Container.name]: Container,
    [Main.name]: Main,
    [Footer.name]: Footer,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Pagination.name]: Pagination,
    [Tag.name]: Tag,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    current: {
      type: Number,
    },
    total: {
      type: Number,
    },
    size: {
      type: Number,
    },
    rows: {
      type: Array,
    },
  },
  data() {
    return {
      dateColumn: "effectiveAt",
      options: [
        {
          label: "发布时间",
          value: "effectiveAt",
        },
        {
          label: "创建时间",
          value: "createdAt",
        },
      ],
    };
  },
  methods: {
    obtainDate(row) {
      if (this.dateColumn === "createdAt") {
        return row["createdAt"];
      }
      if (this.dateColumn === "effectiveAt") {
        return row["effectiveAt"] || row["publishedAt"];
      }
      return "未支持的时间类型";
    },
    handlePublish(row) {
      this.$emit("publish", row);
    },
    handleUnpublish(row) {
      this.$emit("unpublish", row);
    },
    handleSizeChange(val) {
      const payload = {
        pageIndex: this.$props.current,
        pageSize: val,
      };
      this.$emit("search", payload);
    },
    handleCurrentChange(val) {
      const payload = {
        pageIndex: val,
        pageSize: this.$props.size,
      };
      this.$emit("search", payload);
    },
    handleShare(row) {
      this.$emit("share", row);
    },
    handleCommand({ type, row }) {
      switch (type) {
        case "edit":
          if (row.published && row.effective && !row.expired) {
            Message({
              message: "请先停止收集表",
              type: "warning",
            });
          } else {
            this.$emit("edit", row);
          }
          break;
        case "count":
          if (row.postTimes) {
            this.$emit("count", row);
          } else {
            MessageBox.confirm(
              "当前问卷没有收集结果，<br/>是否先分享当前收集表？",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                // type: "warning",
                dangerouslyUseHTMLString: true,
              }
            ).then(() => {
              this.$emit("share", row);
            });
          }
          break;
        case "delete":
          MessageBox.confirm("确认删除当前收集表？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }).then(() => {
            this.$emit("delete", row);
          });
          break;
        default:
          Message.error("还未实现的功能");
          break;
      }
    },
  },
};
</script>
<style>
.qaac-table.el-table {
  border-left: none;
}
.qaac-table.el-table::before,
.qaac-table.el-table::after {
  content: none;
  height: 0;
  width: 0;
}
.qaac-table.el-table.el-table--border .el-table__header-wrapper,
.qaac-table.el-table.el-table--border .el-table__body {
  border-left: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}
.qaac-table.el-table.el-table--border .el-table__body tbody .el-table__row {
  border-left: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}
.cell > .el-select,
.cell > .el-select > .el-input {
  padding-left: 0;
  padding-right: 0;
}
.cell > .el-select > .el-input > input {
  text-align: right;
  border: none;
  padding-right: 25px;
  color: #909399;
  line-height: 28px;
  font-weight: 700;
  font-size: 14px;
}
.cell > .el-select > .el-input.el-input--suffix > .el-input__suffix {
  line-height: 28px;
}
</style>
